import React, { useContext, useState } from 'react';
import {
  DataGrid,
  Text,
  Paper,
  useResponsiveParams,
  Button,
  Label,
} from 'quanta-ui';
// import { updateFireQuote } from '../../_graphql/state';
import { updateFireQuote,updateFireQuoteUploadDocsVar } from 'quanta-flows/modules/quote/fire/state';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons';
// import { ModalViewBreakupFire } from '../../../../../common/view-breakup/exports';
import { ModalViewBreakupFire } from 'quanta-flows/modules/common/viewBreakUp';
import ModalViewFloaterLocations from './modalViewFloaterLocations';
// import Parse from '../../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
// import { ConfigContext } from '../../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';

export default function LocationCoverageDetails({
  fireQuote,
  fireQuoteUploadDocs,
  goToStep,
  values,
  productName,
  getDefaultClauses,
  getDefaultConditions,
  getDefaultWarranties,
  getDefaultExclusions,
  role,
}) {
  const isQuoteReadOnly =
    [
    'quote saved',
    'underwriter approved',
    'underwriter rejected',
    'converted to proposal',
    ]?.includes(fireQuote?.status?.toString()?.toLowerCase()) ||
    (role?.toString()?.toLowerCase() !== 'underwriter' &&
      fireQuote?.status?.toString()?.toLowerCase() ===
        'pending uw approval');

  const RiskLocationDetails = ({
    riskLocation,
    riskLocationIndex,
  }) => {
    const [showViewBreakup, setShowViewBreakup] = useState(false);
    return (
      <Paper>
        <Text
          className={'flex space-x-2 divide-x-2 divide-white h-24'}
        >
          <Text
            className={
              'flex flex-col justify-center items-center w-24 space-y-1'
            }
          >
            <Text severity={'info'}>
              <FontAwesomeIcon icon={faMapMarkerAlt} size={'2x'} />
            </Text>
            <Text
              severity={'info'}
              className={'font-semibold whitespace-nowrap'}
            >
              riskLocation={fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType}
            </Text>
          </Text>
          <Text
            className={`flex justify-between items-center flex-wrap w-full ${
              screenType?.toString()?.toLowerCase() === 'mobile'
                ? 'pl-2'
                : 'pl-5'
            }`}
          >
            {screenType?.toString()?.toLowerCase() !== 'mobile' && (
              <Text>
                {[
                  riskLocation?.addressDetails?.addressLine1,
                  riskLocation?.addressDetails?.pincode,
                  riskLocation?.addressDetails?.district,
                  riskLocation?.addressDetails?.state,
                ]?.filter((d) => d)?.length === 0 ? (
                  <Text severity={'neutral-darker'}>
                    Not Captured
                  </Text>
                ) : (
                  <>
                    {[
                      riskLocation?.addressDetails?.addressLine1,
                      riskLocation?.addressDetails?.district,
                    ]
                      ?.filter((d) => d)
                      ?.join(',')}
                    <br />
                    {[
                      riskLocation?.addressDetails?.pincode,
                      riskLocation?.addressDetails?.state,
                    ]
                      ?.filter((d) => d)
                      ?.join(',')}
                  </>
                )}
              </Text>
            )}
            <Text
              className={'flex flex-col justify-start items-center'}
            >
              <Label
                severity={'info'}
                text={'Annual Premium (inclusive of taxes)'}
              >
                <Text
                  severity={'info'}
                  className={`flex ${
                    screenType?.toString()?.toLowerCase() === 'mobile'
                      ? 'justify-start'
                      : 'justify-end'
                  } items-center space-x-2 mt-1`}
                >
                  <Text severity={'info'} type={'larger'}>
                    {`${CurrencyFormater(
                      riskLocation?.locationPremium
                        ?.locationTotalPremium,
                      true,
                      false,
                      branding,
                      true,
                    )}`}
                  </Text>
                  {screenType?.toString()?.toLowerCase() !==
                  'mobile' ? (
                    <Text
                      className={'quanta_link'}
                      type={'label'}
                      onClick={(_) => setShowViewBreakup(true)}
                    >
                      View Breakup
                    </Text>
                  ) : (
                    <Text
                      type={'label'}
                      severity={'info'}
                      className={'-mb-1'}
                    >
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        size={'lg'}
                        onClick={(_) => setShowViewBreakup(true)}
                      />
                    </Text>
                  )}
                </Text>
              </Label>
            </Text>
          </Text>
        </Text>
        <Text>
          <ModalViewBreakupFire
            {...{
              setShowViewBreakup,
              showViewBreakup,
              title: 'Premium breakup for quote',
              productName,
              locationPremium: riskLocation?.locationPremium,
            }}
          />
        </Text>
      </Paper>
    );
  };
  const { branding } = useContext(QuantaConfigContext);

  const [showFloaterViewBreakup, setShowFloaterViewBreakup] =
    useState(false);
  const [showFloaterLocation, setShowViewFloaterLocation] =
    useState(false);

  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });

  const repeat = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 3,
  });
  const locCoveragaData = [
    ...(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
      ?.length > 0 &&
    // fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
    //   ?.toString()
    //   ?.toLowerCase() === 'home building and home contents'
      fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.map(
          (riskLocation, riskLocationIndex) => {
            return [
              {
                text: (
                  <RiskLocationDetails
                    // riskLocationIndex={riskLocationIndex}
                    riskLocation={fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType}
                  />
                ),
                className: 'my-2',
                colSpan: repeat,
              },
            ];
          },
        )
      // : fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
      //     ?.toString()
      //     ?.toLowerCase() === 'home building only'
          ? fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.map(
            // (riskLocation, riskLocationIndex) => {
            //   return [
            //     {
            //       text: (
            //         <RiskLocationDetails
            //           // riskLocationIndex={riskLocationIndex}
            //           riskLocation={fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType}
            //         />
            //       ),
            //       className: 'my-2',
            //       colSpan: repeat,
            //     },
            //   ];
            // },
          )
      : []),
  ];
  // const locCoveragaData1 = [
  //   ...(fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
  //     ?.length > 0 &&
  //   fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
  //     ?.toString()
  //     ?.toLowerCase() === 'non floater'
  //     ? fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.flatMap(
  //         (riskLocation, riskLocationIndex) => {
  //           return [
  //             {
  //               text: (
  //                 <RiskLocationDetails
  //                   riskLocationIndex={riskLocationIndex}
  //                   riskLocation={riskLocation}
  //                 />
  //               ),
  //               className: 'my-2',
  //               colSpan: repeat,
  //             },
  //           ];
  //         },
  //       )
  //     : fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
  //         ?.toString()
  //         ?.toLowerCase() === 'floater'
  //     ? [
  //         {
  //           text: (
  //             <Paper>
  //               <Text
  //                 className={`flex ${
  //                   screenType
  //                     ?.toString()
  //                     ?.toString()
  //                     ?.toLowerCase() === 'mobile'
  //                     ? 'space-x-2'
  //                     : 'mx-8 space-x-8'
  //                 } divide-x-2 divide-white h-24`}
  //               >
  //                 <Text
  //                   severity={'info'}
  //                   className="flex items-center justify-center"
  //                 >
  //                   <FontAwesomeIcon
  //                     icon={faMapMarkerAlt}
  //                     size={
  //                       screenType
  //                         ?.toString()
  //                         ?.toString()
  //                         ?.toLowerCase() === 'mobile'
  //                         ? '1x'
  //                         : '2x'
  //                     }
  //                   />
  //                 </Text>
  //                 <Text
  //                   className={
  //                     'flex justify-between items-center flex-wrap w-full pl-5'
  //                   }
  //                 >
  //                   <Text
  //                     className={
  //                       screenType?.toString()?.toLowerCase() ===
  //                       'mobile'
  //                         ? 'flex flex-col'
  //                         : 'flex space-x-2'
  //                     }
  //                   >
  //                     <Text
  //                       className={'font-semibold'}
  //                       severity={'info'}
  //                     >
  //                       {`Risk Location 1`}
  //                     </Text>
  //                     <Text
  //                       type={'label'}
  //                       className="quanta_link"
  //                       onClick={(_) =>
  //                         setShowViewFloaterLocation(true)
  //                       }
  //                     >
  //                       View Floater Locations
  //                     </Text>
  //                   </Text>
  //                   <Text className="flex flex-col">
  //                     <Text type={'label'} severity={'info'}>
  //                       {screenType?.toString()?.toLowerCase() ===
  //                       'desktop'
  //                         ? 'Annual Premium (inclusive of taxes)'
  //                         : 'Annual Premium'}
  //                     </Text>
  //                     <Text className="flex space-x-2">
  //                       <Text
  //                         severity={'info'}
  //                         type={'larger'}
  //                       >{`${Parse(
  //                         fireQuote?.tabDetails
  //                           ?.riskLocationTabDetails?.floaterType
  //                           ?.locationPremium?.locationTotalPremium,
  //                         true,
  //                         false,
  //                         branding,
  //                         true,
  //                       )}`}</Text>
  //                       <Text>
  //                         {screenType?.toString()?.toLowerCase() !==
  //                         'mobile' ? (
  //                           <Text
  //                             className={'quanta_link p-1'}
  //                             type={'label'}
  //                             onClick={(_) =>
  //                               setShowFloaterViewBreakup(true)
  //                             }
  //                           >
  //                             View Breakup
  //                           </Text>
  //                         ) : (
  //                           <Text type={'label'} severity={'info'}>
  //                             <FontAwesomeIcon
  //                               icon={faInfoCircle}
  //                               size={'lg'}
  //                               onClick={(_) =>
  //                                 setShowFloaterViewBreakup(true)
  //                               }
  //                             />
  //                           </Text>
  //                         )}
  //                       </Text>
  //                     </Text>
  //                   </Text>
  //                 </Text>
  //               </Text>
  //               <Text>
  //                 <ModalViewBreakupFire
  //                   {...{
  //                     setShowViewBreakup: setShowFloaterViewBreakup,
  //                     showViewBreakup: showFloaterViewBreakup,
  //                     title: 'Premium breakup for quote',
  //                     productName,
  //                     locationPremium:
  //                       fireQuote?.tabDetails?.riskLocationTabDetails
  //                         ?.floaterType?.locationPremium,
  //                   }}
  //                 />
  //               </Text>
  //               <Text>
  //                 <ModalViewFloaterLocations
  //                   {...{
  //                     setShowViewFloaterLocation,
  //                     showFloaterLocation,
  //                     floaterLocations:
  //                       fireQuote?.tabDetails?.riskLocationTabDetails
  //                         ?.floaterType?.floaterLocations,
  //                   }}
  //                 />
  //               </Text>
  //             </Paper>
  //           ),
  //           colSpan: repeat,
  //         },
  //       ]
  //     : []),
  // ];
  return (
    <>
      <Text
        type={'title'}
        className={`w-full flex ${
          screenType?.toString()?.toLowerCase() === 'mobile'
            ? 'flex-wrap'
            : ''
        } -mb-2 items-center space-x-2`}
        severity={'info'}
      >
        <Text
          type={'title'}
          className={`flex ${
            screenType?.toString()?.toLowerCase() !== 'mobile'
              ? 'whitespace-nowrap'
              : ''
          }`}
        >
          Location {'&'} Coverage Details
        </Text>
        <Text className={'flex items-center h-full w-full'}>
          {isQuoteReadOnly ? (
            <Text
              type={'label'}
              className={
                'quanta_link flex flex-col justify-center items-center -mb-0.5'
              }
              onClick={(_) => {
                goToStep(1);
                if (values) {
                  updateFireQuote({
                    currentTab: 1,
                    tabDetails: {
                      ...fireQuote?.tabDetails,
                      additionalTabDetails: {
                        ...fireQuote?.tabDetails
                          ?.additionalTabDetails,
                        underwriterComment:
                          values?.underwriterComment,
                      },
                    },
                  });
                }
              }}
            >
              View Details
            </Text>
          ) : (
            <Button
              flat
              type={'button'}
              className={`w-16 max-h-8`}
              size={'small'}
              onClick={(e) => {
                goToStep(1);
                updateFireQuote({
                  currentTab: 1,
                  tabDetails: {
                    ...fireQuote?.tabDetails,
                    additionalTabDetails: values
                      ? {
                          warranties: {
                            defaultWarranties:
                              getDefaultWarranties?.map(
                                (warranty) =>
                                  warranty?.warrantyShortDescription,
                              )
                                ? getDefaultWarranties?.map(
                                    (warranty) =>
                                      warranty?.warrantyShortDescription,
                                  )
                                : [],
                            userDefinedWarranties:
                              values?.userDefinedWarranties
                                ?.filter((udw) => udw?.warranty)
                                ?.map((udw) => {
                                  return udw?.warranty;
                                })
                                ? values?.userDefinedWarranties
                                    ?.filter((udw) => udw?.warranty)
                                    ?.map((udw) => {
                                      return udw?.warranty;
                                    })
                                : [],
                          },
                          exclusions: {
                            defaultExclusions:
                              getDefaultExclusions?.map(
                                (exclusion) =>
                                  exclusion?.exclusionShortDescription,
                              )
                                ? getDefaultExclusions?.map(
                                    (exclusion) =>
                                      exclusion?.exclusionShortDescription,
                                  )
                                : [],
                            userDefinedExclusions:
                              values?.userDefinedExclusions
                                ?.filter((ude) => ude?.exclusion)
                                ?.map((ude) => {
                                  return ude?.exclusion;
                                })
                                ? values?.userDefinedExclusions
                                    ?.filter((ude) => ude?.exclusion)
                                    ?.map((ude) => {
                                      return ude?.exclusion;
                                    })
                                : [],
                          },
                          clauses: {
                            defaultClauses: getDefaultClauses?.map(
                              (clause) => clause?.clauseDescription,
                            )
                              ? getDefaultClauses?.map(
                                  (clause) =>
                                    clause?.clauseDescription,
                                )
                              : [],
                            userDefinedClauses:
                              values?.userDefinedClauses
                                ?.filter((udc) => udc?.clause)
                                ?.map((udc) => {
                                  return udc?.clause;
                                })
                                ? values?.userDefinedClauses
                                    ?.filter((udc) => udc?.clause)
                                    ?.map((udc) => {
                                      return udc?.clause;
                                    })
                                : [],
                          },
                          conditions: {
                            defaultConditions:
                              getDefaultConditions?.map(
                                (condition) =>
                                  condition?.conditionShortDescription,
                              )
                                ? getDefaultConditions?.map(
                                    (condition) =>
                                      condition?.conditionShortDescription,
                                  )
                                : [],
                            userDefinedConditions:
                              values?.userDefinedConditions
                                ?.filter((udc) => udc?.condition)
                                ?.map((udc) => {
                                  return udc?.condition;
                                })
                                ? values?.userDefinedConditions
                                    ?.filter((udc) => udc?.condition)
                                    ?.map((udc) => {
                                      return udc?.condition;
                                    })
                                : [],
                          },
                          underwriterComment:
                            values?.underwriterComment
                              ? values?.underwriterComment
                              : '',
                        }
                      : fireQuote?.tabDetails?.additionalTabDetails,
                  },
                });
                if (values) {
                  updateFireQuoteUploadDocsVar({
                    documentDetails: values?.documentDetails,
                  });
                } else if (fireQuoteUploadDocs) {
                  updateFireQuoteUploadDocsVar({
                    documentDetails:
                      fireQuoteUploadDocs?.documentDetails,
                  });
                }
              }}
            >
              Change
            </Button>
          )}
        </Text>
      </Text>
      <Text>
        <DataGrid
          data={locCoveragaData}
          flow="cols"
          repeat={repeat}
          gapX={6}
          textType="normal"
          gapY={4}
          spaceY={2}
          nullData={() => (
            <Text severity={'neutral'}>Not Captured</Text>
          )}
        />
      </Text>
    </>
  );
}
